
import { defineComponent, onActivated, onBeforeUnmount, onDeactivated, onMounted, nextTick, reactive } from 'vue'
import { init, EChartsOption } from 'echarts'
import { getLanguage } from "@/utils/cookies";
import i18n from "@/locales";
const _t = i18n.global.t;
export default defineComponent({
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        id: {
            type: String,
            default: 'taskEcharts'
        },
        width: {
            type: String,
            default: getLanguage() == 'nl' ? '470px' : '430px',
            required: true
        },
        height: {
            type: String,
            default: '300px',
            required: true
        },
        chartsData: {
            type: Array,
            default: ''
        }
    },
    setup(props) {

        const state = reactive({
            colorArr: [] as any,
            lang: getLanguage(),
            getlanguages1() {
                if (state.lang == 'ko') {
                    return '65%'
                } else if (state.lang == 'en') {
                    return '61%'
                } else if (state.lang == 'de') {
                    return '63%'
                } else if (state.lang == 'fr') {
                    return '61%'
                }else if (state.lang == 'nl') {
                    return '53%'
                }else if (state.lang == 'pl') {
                    return '57%'
                } else {
                    return '65%'
                }
            },
            graphic_left() {
                if (state.lang == 'en') {
                    return 105
                } else if (state.lang == 'zh-cn') {
                    return 105
                } else if (state.lang == 'ko') {
                    return 98
                } else if (state.lang == 'de') {
                    return 92
                } else if (state.lang == 'fr') {
                    return 80
                } else if (state.lang == 'ja') {
                    return 100
                } else if (state.lang == 'nl') {
                    return 80
                } else if (state.lang == 'pl') {
                    return 90
                }
            }
        })
        // 圆形图
        const initChart = () => {
            const color = function () {
                props.chartsData.forEach((item: any) => {
                    if (item.new_state == 1) {
                        state.colorArr.push('#45A0FF')
                    } else if (item.new_state == 3) {
                        state.colorArr.push('#59CB74')
                    } else if (item.new_state == 4) {
                        state.colorArr.push('#FBD34A')
                    } else if (item.new_state == 5) {
                        state.colorArr.push('#F4657B')
                    } else if (item.new_state == 6) {
                        state.colorArr.push('#535665')
                    }
                })
                return state.colorArr
            }
            const yuanEcharts = init(document.getElementById(props.id) as HTMLDivElement)
            yuanEcharts.setOption({
                title: {
                    // text: _t('robot.percentageTasksCompletedTotal'),
                    textStyle: {
                        fontWeight: 600,
                        fontSize: 15
                    },
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    top: '24%',
                    left: state.getlanguages1(),
                    formatter: function (params) {
                        if (params) {
                            let word_number
                            if (state.lang == 'de') {
                                word_number = 17
                            } else if (state.lang == 'fr' || state.lang == 'en') {
                                word_number = 19
                            }else if (state.lang == 'nl' || state.lang == 'pl') {
                                word_number = 30
                            }
                            else {
                                word_number = 14
                            }
                            let newParamsName = ''// 最终拼接成的字符串
                            let paramsNameNumber = params.length// 实际标签的个数
                            let provideNumber = word_number// 每行能显示的字的个数
                            let rowNumber = Math.ceil(paramsNameNumber / provideNumber)// 换行的话，需要显示几行，向上取整
                            /**
                            * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                            */
                            // 条件等同于rowNumber>1
                            if (paramsNameNumber > provideNumber) {
                                /** 循环每一行,p表示行 */
                                for (let p = 0; p < rowNumber; p++) {
                                    let tempStr = ''// 表示每一次截取的字符串
                                    let start = p * provideNumber// 开始截取的位置
                                    let end = start + provideNumber// 结束截取的位置
                                    // 此处特殊处理最后一行的索引值
                                    if (p === rowNumber - 1) {
                                        // 最后一次不换行
                                        tempStr = params.substring(start, paramsNameNumber)
                                    } else {
                                        // 每一次拼接字符串并换行
                                        tempStr = params.substring(start, end) + '\n'
                                    }
                                    newParamsName += tempStr// 最终拼成的字符串
                                }
                            } else {
                                // 将旧标签的值赋给新标签
                                newParamsName = params
                            }
                            // 将最终的字符串返回
                            return newParamsName
                        } else {
                            return params
                        }
                    },
                },
                graphic: {
                    type: 'text',     // 类型：文本
                    left: state.graphic_left(),
                    bottom: 40,
                    silent: true,     // 不响应事件
                    invisible: props.chartsData.length > 0,   // 有数据就隐藏
                    style: {
                        fill: 'rgba(0, 0, 0, 0.25)',
                        fontWeight: 'bold',
                        text: _t('system.noData'),
                        fontFamily: 'Microsoft YaHei',
                        fontSize: '14',
                        wordWrap: 'break-word'
                    }
                },
                color: props.chartsData.length > 0 ? color() : ['#F2F4F6'],
                series: [
                    {
                        // name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        center: ['30%', '40%'],
                        label: {
                            show: false,
                            position: 'center'
                        },
                        // emphasis: {
                        //   label: {
                        //     show: true,
                        //     fontSize: '40',
                        //     fontWeight: 'bold'
                        //   }
                        // },
                        labelLine: {
                            show: false
                        },
                        data: props.chartsData
                    }
                ]
            } as EChartsOption)
        }

        onMounted(() => {
            setTimeout(() => {
                initChart()
            }, 100)
        })

        onBeforeUnmount(() => {

        })

        onActivated(() => {

        })

        onDeactivated(() => {

        })

        return {

        }
    }
})
